import { getExternalProductStatus } from '@app/shared/lib'

import type { ResponseDto } from '@app/api/dtos'
import type { ExternalProductsListDto } from '@app/api/routes/externalProductsCatalog/dtos'
import type { TableData } from '@app/types/table'
import type { ExternalProductsCatalogDataSource } from '@app/pages/ExternalProductsCatalogPage/types'

const getVolumeWithMeasure = ({ volumeG, volumeMl, volumePieces }: ExternalProductsListDto): string | null => {
  if (volumeG) return `${volumeG} г`
  if (volumeMl) return `${volumeMl} мл`
  if (volumePieces) return `${volumePieces} шт`

  return null
}

export const adaptExternalProductsCatalogTableData = (
  externalProductsListResponse: ResponseDto<ExternalProductsListDto>
): TableData<ExternalProductsCatalogDataSource> => {
  const { count, results: externalProductsList } = externalProductsListResponse

  const dataSource: ExternalProductsCatalogDataSource[] = externalProductsList.map(dto => ({
    key: dto.id,
    code: dto.id ?? null,
    name: dto.name ?? null,
    trend: dto.trend?.name ?? null,
    trendId: dto.trend?.id ?? null,
    purchasingGroup: dto.purchasingGroup?.name ?? null,
    purchasingGroupId: dto.purchasingGroup?.id ?? null,
    commodityGroup: dto.commodityGroup?.name ?? null,
    commodityGroupId: dto.commodityGroup?.id ?? null,
    category: dto.category?.name ?? null,
    categoryId: dto.category?.id ?? null,
    subcategory: dto.subcategory?.name ?? null,
    subcategoryId: dto.subcategory?.id ?? null,
    barcodes: dto.barcodes?.join(', ') ?? null,
    status: getExternalProductStatus(dto),
    isConfirmed: dto.isConfirmed,
    isMatchedWithProduct: dto.isMatchedWithProduct,
    isCHTM: dto.isCHTM ?? null,
    isEPP: dto.isEPP ?? null,
    productCodes: dto.productCodes?.join(', ') ?? null,
    volume: getVolumeWithMeasure(dto),
    brand: dto.brand ?? null,
    manufacturer: dto.manufacturer ?? null,
    regionManufacturer: dto.regionManufacturer ?? null,
    categoryEggs: dto.categoryEggs ?? null,
    shell: dto.shell ?? null,
    fatContentOrFortress: dto.fatContentOrFortress ?? null,
    productForm: dto.productForm ?? null,
    packaging: dto.packaging ?? null
  }))

  return { count, dataSource }
}
